module.exports = __webpack_public_path__ + "static/media/end.63fa1f23.svg";